
import { Component, Prop, Vue } from 'vue-property-decorator'
import TicketCggl from '@/views/Ticket/indexCggl.vue'

@Component({
  name: 'AllMyCreatedOrderLists',
  components: {
    TicketCggl
  }
})
export default class extends Vue {}
